<template>
  <div>
    <VpNavGroup>WhatsApp Broadcast</VpNavGroup>

    <VpSubNavItem
      label="With Cloud API"
      :icon="$options.icons.Whatsapp"
      :to="{ name: 'whatsapp-cloud-api-broadcasts' }"
    />
    <VpSubNavItem
      v-if="isExtensionBroadcastAvailable"
      label="With Extension"
      :icon="$options.icons.Chrome"
      :to="{ name: 'whatsapp-extension-broadcasts' }"
    />
    <VpSubNavItem
      label="Templates"
      :icon="$options.icons.Template"
      :to="{ name: 'whatsapp-templates' }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Whatsapp, Chrome, Template } from "icons/icons.js";

export default {
  icons: {
    Whatsapp,
    Chrome,
    Template,
  },
  computed: {
    ...mapGetters("biz", ["isExtensionBroadcastAvailable"]),
  },
};
</script>
